module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-checkbox__wrapper",
    class: [_vm.size ? _vm.size : 'm', _vm.checked ? 'checked' : 'unchecked'],
    on: {
      "click": function($event) {
        return _vm.$emit('click', $event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "preserveAspectRatio": "xMidYMid meet",
      "x": "0px",
      "y": "0px",
      "widht": "100%",
      "height": "100%",
      "viewBox": "0 0 56.7 56.7"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "47.9,11.8 44.9,8.8 28.3,25.3 11.8,8.8 8.8,11.8 25.3,28.3 8.8,44.9 11.8,47.9 28.3,31.4 44.9,47.9 \n\t47.9,44.9 31.4,28.3 "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0,0v56.7h56.7V0H0z M53.9,53.9h-51v-51h51V53.9z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026cd335","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/g_plugin/btn/Checkbox.vue
// module id = 1951
// module chunks = 1